import styled from 'styled-components';
import { motion } from 'framer-motion';
import { min } from '../../../theme/breakpoints';

export const FAQContainer = styled(motion.section)`
  overflow: hidden;
  position: relative;
  padding: 3.75rem 0;

  @media screen and ${min('largeTablet')} {
    padding: 5rem 0;
  }
  .section-wrapper {
    max-width: 75rem;
  }
`;

export const AccordionSection = styled.ul`
  list-style: none;
  padding: 0;
  margin: 2.5rem 0 0;
  width: 100%;
`;

export const FAQButtonContainer = styled.div`
  text-align: center;
  margin-top: 2.5rem;
`;
